import { useIntl } from 'react-intl';

import { type AuthPrompt } from '@/context/auth/AuthPromptProvider';

import { Legal } from '../Eligibility/styles';
import { SignupScreenProps } from '../shared/types';
import { CalmAccountQuestion } from './CalmAccountQuestion';
import { WelcomeContentWrapper } from './styles';

const Welcome = ({
	compact,
	onScreenChange,
	partnerDetails,
}: Pick<SignupScreenProps, 'compact' | 'onScreenChange' | 'partnerDetails'>) => {
	const { id, name, pageInfo } = partnerDetails;
	const { formatMessage } = useIntl();

	function onCtaClick(mode: AuthPrompt): void {
		onScreenChange('account', mode);
	}

	return (
		<WelcomeContentWrapper>
			<CalmAccountQuestion
				activationMessage={pageInfo.messages.activate}
				compact={compact}
				onCtaClick={onCtaClick}
				partnerId={id}
				partnerName={name}
				partnerDetails={partnerDetails}
			/>
			{pageInfo.messages?.legalWelcome ? (
				<Legal>{formatMessage(pageInfo.messages.legalWelcome)}</Legal>
			) : null}
		</WelcomeContentWrapper>
	);
};

export default Welcome;
